import { Route } from '../Routing/types';
import { DietSettingsMealPlanSummary, DietSettingsDietType } from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/diet-type',
    private: false,
    title: dummy_t('nutritionSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDietType />,
  },
  {
    path: '/summary',
    private: false,
    title: dummy_t('nutritionSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsMealPlanSummary />,
  },
];

export default descendantRoutes;
